import template from './setup.all.html';
import controller from './setup.all.controller';
import './setup.all.scss';

let setupallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default setupallComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/all/setup.all.component.js